export default {
  Title   : 'How was your experience?',
  Subtitle: 'Your review helps us improve',
  Button  : 'Rate Now',
  Comments: 'Review comment',
  Reviews : 'Reviews',
  Success : 'Thanks for your review!'
}
